import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/pages/layout/index'
Vue.use(Router)

export const constantRouterMap = [

  { path: '/login', component: () => import('@/pages/login/index')},
  {
    path: '/',
    component: Layout,
    name: 'gyspErp',
  },
  // { path: '/b2bJobInfo', component: () => import('@/pages/job/b2bJobInfo')},
  // { path: '/freeJobInfo', component: () => import('@/pages/job/freeJobInfo')},
  { path: '*', component: () => import('@/pages/error/404')},
]

export default new Router({
  mode: 'hash',   //history
  routes: constantRouterMap
})
